module.exports = __webpack_public_path__ + "static/tdcw-bc-front-white-6f49598a16a699374022f498b07684bc.png";